import { render } from "./LeftNavbarComponent.vue?vue&type=template&id=61cb002a"
import script from "./LeftNavbarComponent.vue?vue&type=script&lang=js"
export * from "./LeftNavbarComponent.vue?vue&type=script&lang=js"

import "./LeftNavbarComponent.vue?vue&type=style&index=0&id=61cb002a&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__